export const getFullTrackName = (track) =>
  track?.assetName ? `${track?.trackName} - ${track?.assetName}` : track?.trackName;
